import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import { Banner } from '../../../models/BannersModels';

import Modal from '../../../components/Modal/Modal';
import { ModalTitle } from '../../../components/Modal/ModalStyle';
import ClickableIcon from '../../../components/Icons/ClickableIcon';
import { CloseIcon2x } from '../../../components/Icons/CloseIcon';
import BannerReviewContent from './BannerReviewContent';
import useBannersFormContainer from '../BannersForm/components/useBannersFormContainer';

interface BannerPreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  banner: Banner | null;
}

function BannerPreviewModal({ isOpen, onClose, banner }: BannerPreviewModalProps) {
  const [t] = useTranslation();
  const { marketOptions, companiesOptions } = useBannersFormContainer();

  const marketNameById = useMemo(
    () => new Map(marketOptions.map((market) => [market.value, market.label])),
    [marketOptions],
  );
  const companyNameById = useMemo(
    () => new Map(companiesOptions.map((company) => [company.value, company.label])),
    [companiesOptions],
  );

  if (!banner) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      sx={{
        width: '54rem',
        maxWidth: '90vw',
        maxHeight: '90vh',
        alignItems: 'stretch',
        overflowY: 'auto',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '1.5rem' }}>
        <ModalTitle sx={{ textAlign: 'left', color: (theme) => theme.palette.text.primary }}>
          {t('pages.banners.preview.title')}
        </ModalTitle>
        <ClickableIcon onClick={onClose}>
          <CloseIcon2x />
        </ClickableIcon>
      </Box>
      <BannerReviewContent
        formData={banner}
        marketNameById={marketNameById}
        companyNameById={companyNameById}
        status={banner.status}
        isPreview
      />
    </Modal>
  );
}

export default BannerPreviewModal;
